import logoUrl from "../assets/stealth-logo.png";

/**
 * Stealth badge. The asset already carries the gold frame and wordmark, so this is just
 * the image — no CSS ring around it.
 */
export function StealthLogo() {
  return (
    <img className="nl-logo" src={logoUrl} alt="Stealth" width={96} height={96} />
  );
}
